import ShareLinkAndMediaModal from "./ShareLinkAndMediaModal";

export default ShareLinkAndMediaModal;
